export const debug = (...message: unknown[]) => {
  if (!sessionStorage.getItem('IL_debug')) return

  const css = 'background: blue; color: white; border-radius: 5px; padding: 2px'
  console.log('%c%s', css, 'debug', ...message)
}
